function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManThinking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Line--inject-3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 61.58,
    y1: 476.25,
    x2: 461.73,
    y2: 476.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 123.67,
    y1: 324.26,
    x2: 139.55,
    y2: 476.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.73,
    y1: 444.91,
    x2: 129.67,
    y2: 437.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.82,439.69a8,8,0,0,0-2.81-6c-1.81-1.62-11.35-5.63-12.25-2.27C115.77,435.08,125.53,442.26,131.82,439.69Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.82,
    y1: 439.69,
    x2: 122.74,
    y2: 434.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.5,
    y1: 461.88,
    x2: 131.45,
    y2: 454.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.59,456.66a8,8,0,0,0-2.81-6c-1.81-1.62-11.35-5.63-12.25-2.27C117.54,452.05,127.3,459.22,133.59,456.66Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.59,
    y1: 456.66,
    x2: 124.51,
    y2: 451,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.41,
    y1: 403.5,
    x2: 125.35,
    y2: 396.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.5,398.28a8,8,0,0,0-2.81-6c-1.81-1.61-11.35-5.63-12.25-2.27C111.45,393.68,121.21,400.85,127.5,398.28Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.5,
    y1: 398.28,
    x2: 118.42,
    y2: 392.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.18,
    y1: 420.47,
    x2: 127.12,
    y2: 413.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.27,415.25a8,8,0,0,0-2.81-6c-1.81-1.62-11.35-5.63-12.25-2.27C113.22,410.64,123,417.82,129.27,415.25Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.27,
    y1: 415.25,
    x2: 120.19,
    y2: 409.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.54,
    y1: 375.94,
    x2: 122.48,
    y2: 368.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.62,370.72a8,8,0,0,0-2.81-6c-1.81-1.62-11.35-5.63-12.25-2.27C108.58,366.11,118.34,373.29,124.62,370.72Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.62,
    y1: 370.72,
    x2: 115.54,
    y2: 365.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.65,
    y1: 348.26,
    x2: 119.59,
    y2: 340.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.73,343a8,8,0,0,0-2.81-6c-1.81-1.62-11.34-5.63-12.25-2.27C105.69,338.43,115.45,345.6,121.73,343Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.73,
    y1: 343.03,
    x2: 112.65,
    y2: 337.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.55,
    y1: 434.87,
    x2: 140.91,
    y2: 426.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.28,428.75a8,8,0,0,1,1.51-6.44c1.44-2,9.94-7.85,11.52-4.75C154,420.93,146,430,139.28,428.75Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.28,
    y1: 428.75,
    x2: 147.45,
    y2: 420.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.89,
    y1: 390.22,
    x2: 136.25,
    y2: 381.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.62,384.09a8,8,0,0,1,1.51-6.43c1.44-2,9.94-7.86,11.52-4.76C149.37,376.27,141.3,385.31,134.62,384.09Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.62,
    y1: 384.09,
    x2: 142.79,
    y2: 376.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.84,
    y1: 370.59,
    x2: 134.21,
    y2: 361.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.57,364.47a8,8,0,0,1,1.51-6.44c1.44-1.95,9.94-7.85,11.52-4.75C147.32,356.65,139.25,365.69,132.57,364.47Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.57,
    y1: 364.47,
    x2: 140.74,
    y2: 356.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.84,
    y1: 341.83,
    x2: 131.2,
    y2: 333.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,335.7a8,8,0,0,1,1.51-6.44c1.44-1.95,9.94-7.85,11.52-4.75C144.32,327.88,136.25,336.92,129.57,335.7Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.57,
    y1: 335.7,
    x2: 137.74,
    y2: 327.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54,323.43a8,8,0,0,1,1.51-6.43c1.44-2,9.94-7.86,11.52-4.76C138.29,315.61,130.22,324.65,123.54,323.43Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.54,
    y1: 323.43,
    x2: 131.72,
    y2: 315.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,323.77a8,8,0,0,1-6.25-2.18c-1.8-1.63-6.77-10.71-3.52-11.95C117.78,308.28,125.92,317.26,124,323.77Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.02,
    y1: 323.77,
    x2: 117.1,
    y2: 314.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.74,
    y1: 344.81,
    x2: 151.61,
    y2: 476.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.68,
    y1: 465.56,
    x2: 147.31,
    y2: 456.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,459.44a8,8,0,0,0-1.52-6.44c-1.44-1.95-9.94-7.84-11.52-4.74C134.19,451.63,142.27,460.66,149,459.44Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.95,
    y1: 459.44,
    x2: 141.23,
    y2: 452.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.98,
    y1: 424.15,
    x2: 151.61,
    y2: 415.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.24,418a8,8,0,0,0-1.51-6.44c-1.44-1.95-9.95-7.84-11.52-4.74C138.49,410.22,146.56,419.25,153.24,418Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.24,
    y1: 418.03,
    x2: 145.53,
    y2: 410.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.22,
    y1: 441.12,
    x2: 149.84,
    y2: 432.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.48,435a8,8,0,0,0-1.51-6.44c-1.44-1.95-9.95-7.84-11.53-4.74C136.73,427.19,144.8,436.22,151.48,435Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.48,
    y1: 435,
    x2: 143.76,
    y2: 427.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.84,
    y1: 396.59,
    x2: 154.47,
    y2: 387.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.1,390.47a8,8,0,0,0-1.51-6.44c-1.44-2-10-7.85-11.52-4.75C141.35,382.65,149.42,391.68,156.1,390.47Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.1,
    y1: 390.47,
    x2: 148.39,
    y2: 383.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.71,
    y1: 368.9,
    x2: 157.34,
    y2: 360.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,362.78a8,8,0,0,0-1.52-6.44c-1.44-1.95-9.94-7.84-11.52-4.74C144.22,355,152.3,364,159,362.78Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.98,
    y1: 362.78,
    x2: 151.26,
    y2: 355.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.59,
    y1: 455.49,
    x2: 160.64,
    y2: 448.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5,450.27a8,8,0,0,1,2.8-6c1.81-1.62,11.35-5.64,12.26-2.28C174.54,445.65,164.79,452.83,158.5,450.27Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.5,
    y1: 450.27,
    x2: 168.11,
    y2: 444.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.22,
    y1: 410.84,
    x2: 165.28,
    y2: 403.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.13,405.61a8,8,0,0,1,2.81-6c1.81-1.62,11.34-5.63,12.25-2.28C179.18,401,169.42,408.18,163.13,405.61Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.13,
    y1: 405.61,
    x2: 172.74,
    y2: 399.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.26,
    y1: 391.21,
    x2: 167.31,
    y2: 383.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.17,386a8,8,0,0,1,2.8-6c1.81-1.62,11.35-5.64,12.26-2.28C181.21,381.37,171.46,388.55,165.17,386Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.17,
    y1: 385.99,
    x2: 174.78,
    y2: 380.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.24,
    y1: 362.44,
    x2: 170.3,
    y2: 354.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.15,357.22a8,8,0,0,1,2.81-6c1.81-1.62,11.34-5.64,12.25-2.28C184.2,352.6,174.44,359.78,168.15,357.22Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.15,
    y1: 357.22,
    x2: 177.76,
    y2: 351.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.78,344a8,8,0,0,1,2.81-6c1.81-1.62,11.34-5.63,12.25-2.27C180.83,339.36,171.07,346.54,164.78,344Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.78,
    y1: 343.97,
    x2: 174.39,
    y2: 338.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.18,344.4a8,8,0,0,1-5.66-3.42c-1.43-2-4.42-11.87-1-12.42C162.27,328,168.39,338.42,165.18,344.4Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.18,
    y1: 344.4,
    x2: 160.25,
    y2: 334.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147,
    y1: 284.05,
    x2: 146.03,
    y2: 476.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.15,
    y1: 444.37,
    x2: 140.9,
    y2: 436.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,438.66a8,8,0,0,0-2.17-6.24c-1.63-1.8-10.7-6.78-11.95-3.54C127.32,432.42,136.28,440.56,142.8,438.66Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.8,
    y1: 438.66,
    x2: 134.36,
    y2: 432.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.15,
    y1: 408.91,
    x2: 140.9,
    y2: 400.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,403.2a8,8,0,0,0-2.17-6.24c-1.63-1.8-10.7-6.78-11.95-3.53C127.32,397,136.28,405.1,142.8,403.2Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.8,
    y1: 403.2,
    x2: 134.36,
    y2: 396.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.15,
    y1: 367.28,
    x2: 140.9,
    y2: 359.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,361.57a8,8,0,0,0-2.17-6.24c-1.63-1.8-10.7-6.78-11.95-3.53C127.32,355.33,136.28,363.47,142.8,361.57Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.8,
    y1: 361.57,
    x2: 134.36,
    y2: 355,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.15,
    y1: 339.56,
    x2: 140.9,
    y2: 331.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,333.86a8,8,0,0,0-2.17-6.25c-1.63-1.79-10.7-6.77-11.95-3.53C127.32,327.61,136.28,335.76,142.8,333.86Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.8,
    y1: 333.86,
    x2: 134.36,
    y2: 327.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.15,
    y1: 311.73,
    x2: 140.9,
    y2: 303.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,306a8,8,0,0,0-2.17-6.25c-1.63-1.8-10.7-6.78-11.95-3.53C127.32,299.78,136.28,307.93,142.8,306Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.8,
    y1: 306.03,
    x2: 134.36,
    y2: 299.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.01,
    y1: 455.19,
    x2: 153.26,
    y2: 447.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.36,449.49a8,8,0,0,1,2.17-6.25c1.63-1.79,10.7-6.77,11.95-3.53C166.84,443.24,157.87,451.39,151.36,449.49Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.36,
    y1: 449.49,
    x2: 160.3,
    y2: 442.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.01,
    y1: 398.8,
    x2: 153.26,
    y2: 390.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.36,393.1a8,8,0,0,1,2.17-6.25c1.63-1.8,10.7-6.78,11.95-3.53C166.84,386.85,157.87,395,151.36,393.1Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.36,
    y1: 393.1,
    x2: 160.3,
    y2: 386.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.01,
    y1: 370.96,
    x2: 153.26,
    y2: 362.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.36,365.26a8,8,0,0,1,2.17-6.25c1.63-1.79,10.7-6.77,11.95-3.53C166.84,359,157.87,367.16,151.36,365.26Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.36,
    y1: 365.26,
    x2: 160.3,
    y2: 358.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.01,
    y1: 334.17,
    x2: 153.26,
    y2: 326.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.36,328.47a8,8,0,0,1,2.17-6.25c1.63-1.79,10.7-6.77,11.95-3.53C166.84,322.22,157.87,330.37,151.36,328.47Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.36,
    y1: 328.47,
    x2: 160.3,
    y2: 321.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.01,
    y1: 305.25,
    x2: 153.26,
    y2: 297.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.36,299.55a8,8,0,0,1,2.17-6.25c1.63-1.8,10.7-6.78,11.95-3.53C166.84,293.3,157.87,301.45,151.36,299.55Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.36,
    y1: 299.55,
    x2: 160.3,
    y2: 292.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.64,286.72a8,8,0,0,1,2.17-6.25c1.63-1.8,10.7-6.77,11.95-3.53C162.12,280.47,153.15,288.62,146.64,286.72Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.64,
    y1: 286.72,
    x2: 155.58,
    y2: 279.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.07,287.1a8,8,0,0,1-6-2.81c-1.62-1.82-5.62-11.36-2.26-12.26C142.48,271.05,149.65,280.82,147.07,287.1Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.07,
    y1: 287.1,
    x2: 141.13,
    y2: 277.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "401.04 476.25 395.26 409.62 258.41 409.62 250.85 476.25 401.04 476.25",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.22,207.67s-40,11-57.5,24.24-29.6,26.78-26.78,52.43,21.14,95.83,21.14,95.83-2.54,28.47-2.54,30.16-.28,6.48,5.92,6.76,80.61,3.39,97.24,3.67,38.62-1.41,41.15-3.38a11.76,11.76,0,0,0,4.23-8.46c.28-3.38,3.1-44.82,3.1-44.82l.28-18.6s18.33-60.88,19.45-80.61-6.2-26.21-14.37-32.41-33.61-16.7-47.35-20.86S317.22,207.67,317.22,207.67Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.09,302.27c-2,27.45-5.66,78-5.34,86.71.45,12-4.44,15.55-4.44,20",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.42,284.56s-.36,4.67-.91,12.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.28 319.82 348.84 350.02 363.17 349 346.28 319.82",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.7,372.48s35-5.5,37.63-4.92,20.55,9.26,23.16,9.84a24.34,24.34,0,0,1,4.92,1.74l3.93,3.29L401,372.48s-5.21-6.37-16.79-11-17.37-2-20-1.15S332.7,372.48,332.7,372.48Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.88,346.07l91-.29s29.32-2.81,30.44-3.1,12.69,2.82,13.82,3.67,1.12,3.38.56,5.92l-.56,2.53a53.38,53.38,0,0,1,.84,6.49c0,2-2.25,2.53-2.54,3.38s1.7,3.94-.56,5.92l-2.25,2s-.29,5.36-1.41,6.77-4.51,3.94-5.92,3.1-.85-3.1-.85-4.51-.56-2.82-2.25-2.82-2,1.41-10.71-.85-18.32-9.86-19.17-10.15-77.23,20.3-99.78,23.12-24.52-.28-25.37-4-2.25-12.4-2.25-12.4l-4-17.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.05,240.71s4.71-5,7.68-2.73,5.69,14.11,9.4,13.12,11.14-24,11.14-33.16-6.44-14.6-7.92-15.1-39.35-1-43.81.75-6.18,17.32-7.91,26.72,2.22,11.63,4.7,10.4,12.12-5.2,14.35-5.2S338.05,240.71,338.05,240.71Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.4,188.54s-3.55,17.54-4.93,21.87-11.43,17.54-14,20.3-10.05,16.35-12,16.75S325,229.33,325,229.33s-7.1-12.22-8.48-15.37S313,201.55,313,201.55s11.62,10,24,7.88,18.71-14.58,18.71-14.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.29,153.6s-3.47-3.72-5.45,2,2,15.83,2,15.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.91,142s-5.71,40.59-5.71,43-1.58,10.24.79,15.37,9.45,11.42,15.17,12.21,16.94-.39,23.25-5.32S363,191.7,363,191.7s7.89-1.19,13-3.35,9.06-7.1,8.87-12.22a17.18,17.18,0,0,0-3.35-9.06l-3-5.52,7.88-14.78s-4.53-8.47-19.11-16.55-27.59-10.64-33.69-10.64-13.8,2.56-16,7.49S315.91,142,315.91,142Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.63,122.14s11.23,18.52,19.71,17.74,11-4.73,11-4.73l5.71,7.68s-6.1,2.56-4.92,5.72,6.5,10.24,6.5,10.24l-4.34,18.52s3.35.59,3.95-.59,3.54-8.47,3.54-8.47a10.22,10.22,0,0,1,2.56-1.18,7.52,7.52,0,0,1,3.16,0s2.16-7.29,3-7.49,8.67-2.37,11.63-10.05-1.58-19.9-11.83-29.55-31.92-12.22-33.1-14,5.52.78,4.14-3.16-10.05-9.06-21.08-3.54-9.46,11.62-8.28,13.59l1.18,2s-9.26-3.15-15.76.79-9.65,11.82-6.7,12.61,6.7-1,6.7-1-3.94,6.5-2.76,7.88,7.29,6.89,7.29,6.89,2.37-13.79,7.29-15.76S334.63,122.14,334.63,122.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "331.08 148.74 332.86 154.46 322.81 173.37 333.45 177.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.11,146.57s-4.72-3.74-8.67-2.75-1.57,1.57,1.19,2.56S329.9,149.92,329.11,146.57Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.7,145.79s-4.54,1.18-2.37,2.16,8.67-1,11.23,0,5.91,4.34,5.72,2.76A8,8,0,0,0,353,144.8C349.41,143.62,343.7,145.79,343.7,145.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.51,155.32c-.35,1.43-1.31,2.42-2.16,2.21s-1.25-1.52-.91-2.95,1.32-2.42,2.16-2.22S326.85,153.89,326.51,155.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,160.94c-.35,1.42-1.32,2.41-2.16,2.21s-1.25-1.53-.91-3,1.31-2.42,2.16-2.21S348.33,159.51,348,160.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.7,
    y1: 179.87,
    x2: 324.78,
    y2: 185.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.8,227.68s27.9,10.72,33.26,26.78-1.41,36.36-4.23,44.82-20.29,41.43-23.11,49.32-7.05,17.48-7.05,17.48S394.73,342.4,384,327.75s-13.25-27.91-13.25-27.91,19.45-34.39,24.52-45.1",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.73,293.88s5.71-2.85,7.61-1.9,26.33,14,29.5,28.87a50.55,50.55,0,0,1-4.44,33c-2.86,5.4-8.25,15.86-12.37,17.13s-7.62-32.67-16.18-50.43S373.73,293.88,373.73,293.88Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.17,277.57s5.07-17.19,7.05-23.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.27,216.52s-7.88-11-14-18.32-12.42-11.63-14.58-11-3,2.76-1.58,5.32,7.88,8.28,9.06,9.86,3,7.29,3,7.29-5.71.39-6.7,1.57a26.41,26.41,0,0,0-2.36,4.34,8.37,8.37,0,0,0-3,2.56,7,7,0,0,0-1.18,2.76c-.2.79-3,2.17-2.76,5.71s3.55,8.67,4.73,11,9.85,12.8,11.43,14.58,10.64,17.53,13,22.85,25.22,67,31.92,76.26,19.11,18.12,25.81,21.28,11.43-2.17,14.58-8.87,5.91-20.1-.19-35.47-18.13-28.57-27.39-36.45-26.6-27.58-28.57-31.13S339,249.23,339,249.23s5.12-15,5.51-18.52-1.57-9.85-1-12.61,2.95-8.28,3.94-10.64,4.33-6.31,2.56-8.08-9.06.39-11.62,4.53A120.38,120.38,0,0,0,332.27,216.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.37,259.19c.59-3.13,1-5.29,1-5.29",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.58,226.84s-14.94,2-30.44,18.6-8.74,56.09-7.33,64.27S235.48,343,235.48,343l39.74-13.25s-6.48-44.25-7.05-48.2c-.28-2,.8-9,1.94-15.5",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53,334.23s3.95,21.14,5.92,22.26,32.69-7.32,36.08-7.89,5.35.28,5.35-2.53-2.82-16.07-4.51-18.32-38.33,2.53-41.43,3.38S231.53,334.23,231.53,334.23Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,317.89a159.92,159.92,0,0,1,20.33,9.86s-9.58-18-13.53-21.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.72,315.91c1.13.39,2.25.8,3.35,1.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.16,408.18c7.29-2.6,14-5.46,18-8.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.79,418.22s15.57-3.69,30.35-8.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,398.73c-7.66,3.82-19.79,9.4-29.7,11.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.79,394.83s-1.57.87-4.18,2.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.12,37.14C49.05,69.45,36.33,164.31,78.87,221.33c8.89,11.92,20.51,22,34.28,27.81,47,19.93,84.67-19.7,107.58-56.12,36.58-58.13,41.15-72.5,40.5-62.71S277.56,150.56,287.36,99c12.53-66-79.83-81-126.58-74.76A148.06,148.06,0,0,0,116.12,37.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.97,
    cy: 152.85,
    rx: 14.7,
    ry: 8.82,
    transform: "translate(7.52 318.46) rotate(-61.02)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.69,158.58c-2.32,4.19-2.16,8.73.35,10.12s6.45-.88,8.77-5.07,2.17-8.73-.35-10.12S291,154.38,288.69,158.58Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,31C52.91,63.27,40.19,158.13,82.73,215.15c8.89,11.92,20.52,22,34.28,27.81,47,19.93,84.67-19.7,107.58-56.12,36.58-58.13,41.16-72.5,40.5-62.71s16.33,20.25,26.13-31.35c12.53-66-79.83-81-126.58-74.76A148.06,148.06,0,0,0,120,31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.12,142.4c-3.94,7.1-3.67,14.77.59,17.13s10.9-1.49,14.84-8.59,3.66-14.77-.6-17.13S274.05,135.3,270.12,142.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.56,152.4c-2.33,4.2-2.17,8.73.35,10.12s6.44-.87,8.76-5.07,2.17-8.73-.35-10.12S294.88,148.2,292.56,152.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManThinking);
export default __webpack_public_path__ + "static/media/man_thinking.e161187c85fe4aed23e5959ba7f3e9a9.svg";
export { ForwardRef as ReactComponent };